export default __webpack_public_path__ + "static/IMG-01-b0fbc9d3066ebfba9e6b7a9efe2ea1e7.jpg";